import { all } from "redux-saga/effects";
import getDataCalculateCart from "./getDataCalculateCart";
import getListHistoryOrder from "./getListHistoryOrder";
import getListProducts from "./getListProducts";
import getOrderHistoryDetail from "./getOrderHistoryDetail";
import getProductBrands from "./getProductBrands";
import postCalculateCart from "./postCalculateCart";
import postCreateOrder from "./postCreateOrder";
import setDefaultCart from "./setDefaultCart";

export const orderPageSaga = function* root() {
	yield all([
		getDataCalculateCart(),
		getListHistoryOrder(),
		getListProducts(),
		getOrderHistoryDetail(),
		getProductBrands(),
		postCalculateCart(),
		postCreateOrder(),
		setDefaultCart()
	]);
};
